<template>
  <div>

    <div>
      <h3 class="title-color">Contractor Info</h3>
    </div>

    <div class="e-card-separator"></div>
    <div class="main-container">

      <address-info
        @updateAddress="updateAddress"
        @updateCompanyLegalName="updateCompanyLegalName"
        :company="permit.contractorCompany"
        @updateContactFieldDS="updateContactFieldDS"
        :applier="applier"
      />

      <div class="e-card-separator"></div>

      <contact-info
        ref="contractorContactRef"
        @updateContactNumber="updateContactNumber"
        @updateContactInfo="updateContactInfo"
        :phoneRules="[phoneRule]"
        :emailRules="[emailRule]"
        :applier="applier"
        :contact="permit.contractorContact"
        :contactFieldDataSource="contactFieldDataSource"
      />

    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { emailRule, phoneRule } from '@/shared/constants';
import ContactInfo from './common/contact-info.vue';
import { applierTypeEnum } from './constants';
import AddressInfo from './common/address-info.vue';
import { getEServicesContacts } from '../../auth/services/tms-api';
import {
  updateContactFieldDS,
  updateContactNumber,
  updateContactInfo,
} from './helper';

export default {
  name: 'ContractorInfo',

  components: {
    ContactInfo,
    AddressInfo,
  },

  data() {
    return {
      applier: applierTypeEnum.CONTRACTOR,
      phoneRule,
      emailRule,
      contactFieldDataSource: null,
    };
  },

  computed: {
    ...mapGetters({
      permit: 'permit',
    }),
  },
  watch: {
    async permit(val) {
      // eslint-disable-next-line max-len
      if (val && val.contractorCompany && val.contractorCompany.sourceCompanyId && !this.contactFieldDataSource) {
        if (val.contractorCompany.sourceCompanyId) {
          await getEServicesContacts(val.contractorCompany.sourceCompanyId).then((res) => {
            // eslint-disable-next-line no-return-assign, no-param-reassign
            res.data.forEach((x) => (x.name = `${x.fName} ${x.lName}`));
            this.contactFieldDataSource = res.data;
          });
        } else {
          this.contactFieldDataSource = null;
        }
      }
    },
  },
  methods: {
    updateAddress(e) {
      this.permit.contractorCompany = e;
    },
    updateContactNumber(data) {
      updateContactNumber(data, this.permit.contractorContact);
    },
    updateContactFieldDS(dataSource) {
      updateContactFieldDS(this, dataSource, this.permit.contractorContact);
    },
    updateContactInfo(data) {
      updateContactInfo(data, this.permit.contractorContact);
    },
    updateCompanyLegalName(name) {
      this.permit.contractorCompany.legalName = name;
    },
  },
};
</script>
